import script from "./Alarm.vue?vue&type=script&setup=true&lang=js"
export * from "./Alarm.vue?vue&type=script&setup=true&lang=js"

import "./Alarm.vue?vue&type=style&index=0&id=6305af16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6305af16"]])

export default __exports__